import React from "react"
import PropTypes from "prop-types"
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "reactstrap"

const ConfirmModal = ({
  isOpen,
  title = "Confirm",
  children,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmColor = "danger",
  loading = false,
  errorMessage = "",
  backdrop = "static",
  centered = false,
  modalClassName = "modal-top",
  onCancel,
  onConfirm,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={loading ? undefined : onCancel}
      backdrop={backdrop}
      centered={centered}
      modalClassName={modalClassName}
      keyboard={!loading}
    >
      <ModalHeader toggle={loading ? undefined : onCancel} className="text-black">
        {title}
      </ModalHeader>

      <ModalBody>
        {typeof children === "string" ? <p className="mb-0">{children}</p> : children}
        {!!errorMessage && <p className="error-message mt-2 mb-0 text-start">{errorMessage}</p>}
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={onCancel} disabled={loading}>
          {cancelLabel}
        </Button>
        <Button color={confirmColor} className="add-new-user decline" onClick={onConfirm} disabled={loading}>
          {loading ? (
            <>
              <Spinner size="sm" className="me-2" /> Deleting…
            </>
          ) : (
            confirmLabel
          )}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  children: PropTypes.node,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  confirmColor: PropTypes.string,
  loading: PropTypes.bool,
  errorMessage: PropTypes.string,
  backdrop: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(["static"])]),
  centered: PropTypes.bool,
  modalClassName: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
}

export default ConfirmModal
